import React, { useEffect, useState } from "react";
import styles from "./Contents.module.css";
import Content from "./Content";
import SimpleBtn from "../../../components/Button/SimpleBtn";

function Contents() {
  const [videoByUser, setVideoByUser] = useState([]);

  useEffect(() => {
    const getVideos = async () => {
      try {
        const url = encodeURIComponent(
          "https://www.aparat.com/etc/api/videoByUser/username/TfnNikan"
        );
        const response = await fetch(
          `https://api.allorigins.win/get?url=${url}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const rawData = await response.json();
        const data = JSON.parse(rawData.contents);
        setVideoByUser(data.videobyuser);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    getVideos();
  }, []);

  return (
    <>
      <section
        id="homePage-Contents__sec"
        className={`${styles.ContentsSec} Contents__sec`}>
        <h2 className={`${styles.ContentsTitle} `}>ویدیو ها</h2>
        <div className={`${styles.mediaBtn}`}>
          <SimpleBtn
            className={styles.aparatBtn}
            link="https://www.aparat.com/TfnNikan"
            target="_blank">
            کانال آپارات
          </SimpleBtn>
          {/* <SimpleBtn className={styles.ytBtn}>کانال یوتیوب</SimpleBtn> */}
        </div>

        <div className={`${styles.Contents}`}>
          {videoByUser?.length > 0 ? (
            videoByUser.map((b) => (
              <Content
                key={b.id}
                title={b.title}
                videoUrl={b.frame}
                posterUrl={b.small_poster}
              />
            ))
          ) : (
            <span className={styles.listFailed}>ویدیوئی پیدا نشد...</span>
          )}
        </div>
      </section>
    </>
  );
}

export default Contents;
